import React from 'react';

export default function tourBenefits(t, i18n) {
    return [
        {
            selector: '[data-tut="step_six_tour"]',
            content: ({ goTo }) => (
                <div
                    dir={i18n.dir()}
                    style={{
                        marginRight: i18n.dir() === 'rtl' ? '10px' : '0'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <h4
                            style={{
                                color: '#fff',
                                fontSize: '18px',
                                fontWeight: '700',
                                lineHeight: '22px',
                                marginBottom: '12px'
                            }}
                        >
                            {t('tour.firstStepTitle')}
                        </h4>
                    </div>
                    <p
                        style={{
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: '400',
                            lineHeight: '20px',
                            marginBottom: '16px'
                        }}
                    >
                        {t('tour.firstStepOverView')}
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <p
                            style={{
                                color: '#fff',
                                fontSize: '14px',
                                fontWeight: '700',
                                lineHeight: '17px'
                            }}
                        >
                            {t("stepText", {currentStep: 1, endStep: 4, ns: "common"})}
                        </p>
                        <div
                            style={{
                                display: 'flex'
                            }}
                        >
                            <button
                                style={{
                                    background: '#00508E',
                                    padding: '8px 32px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    display: 'block',
                                    cursor: 'pointer',
                                    border: '0',
                                    color: '#fff'
                                }}
                                onClick={() => goTo(1)}
                            >
                                {t('nextButtonLabel', { ns: 'common' })}
                            </button>
                        </div>
                    </div>
                </div>
            ),
            style: {
                padding: '24px 32px',
                minWidth: '407px',
                background: '#003F75'
            }
        },
        {
            selector: '[data-tut="step_benefit_search_tour"]',
            content: ({ goTo }) => (
                <div
                    dir={i18n.dir()}
                    style={{
                        marginRight: i18n.dir() === 'rtl' ? '10px' : '0'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <h4
                            style={{
                                color: '#fff',
                                fontSize: '18px',
                                fontWeight: '700',
                                lineHeight: '22px',
                                marginBottom: '12px'
                            }}
                        >
                            {t('tour.secondStepTitle')}
                        </h4>
                    </div>
                    <p
                        style={{
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: '400',
                            lineHeight: '20px',
                            marginBottom: '16px'
                        }}
                    >
                        {t('tour.secondStepOverView')}
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <p
                            style={{
                                color: '#fff',
                                fontSize: '14px',
                                fontWeight: '700',
                                lineHeight: '17px'
                            }}
                        >
                            {t("stepText", {currentStep: 2, endStep: 4, ns: "common"})}
                        </p>
                        <div
                            style={{
                                display: 'flex'
                            }}
                        >
                            <button
                                style={{
                                    background: '#00508E',
                                    padding: '8px 32px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    display: 'block',
                                    cursor: 'pointer',
                                    border: '0',
                                    color: '#fff',
                                    marginRight: i18n.dir() === 'rtl' ? '0' : '8px',
                                    marginLeft: i18n.dir() === 'rtl' ? '8px' : '0'
                                }}
                                onClick={() => goTo(0)}
                            >
                                {t('previousButtonLabel', { ns: 'common' })}
                            </button>
                            <button
                                style={{
                                    background: '#00508E',
                                    padding: '8px 32px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    display: 'block',
                                    cursor: 'pointer',
                                    border: '0',
                                    color: '#fff'
                                }}
                                onClick={() => goTo(2)}
                            >
                                {t('nextButtonLabel', { ns: 'common' })}
                            </button>
                        </div>
                    </div>
                </div>
            ),
            style: {
                padding: '24px 32px',
                minWidth: '407px',
                background: '#003F75'
            }
        },
        {
            selector: '[data-tut="step_secondary_care_tour"]',
            content: ({ goTo }) => (
                <div
                    dir={i18n.dir()}
                    style={{
                        marginRight: i18n.dir() === 'rtl' ? '10px' : '0'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <h4
                            style={{
                                color: '#fff',
                                fontSize: '18px',
                                fontWeight: '700',
                                lineHeight: '22px',
                                marginBottom: '12px'
                            }}
                        >
                            {t('tour.thirdStepTitle')}
                        </h4>
                    </div>
                    <p
                        style={{
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: '400',
                            lineHeight: '20px',
                            marginBottom: '16px'
                        }}
                    >
                        {t('tour.thirdStepOverView')}
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <p
                            style={{
                                color: '#fff',
                                fontSize: '14px',
                                fontWeight: '700',
                                lineHeight: '17px'
                            }}
                        >
                            {t("stepText", {currentStep: 3, endStep: 4, ns: "common"})}
                        </p>
                        <div
                            style={{
                                display: 'flex'
                            }}
                        >
                            <button
                                style={{
                                    background: '#00508E',
                                    padding: '8px 32px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    display: 'block',
                                    cursor: 'pointer',
                                    border: '0',
                                    color: '#fff',
                                    marginRight: i18n.dir() === 'rtl' ? '0' : '8px',
                                    marginLeft: i18n.dir() === 'rtl' ? '8px' : '0'
                                }}
                                onClick={() => goTo(2)}
                            >
                                {t('previousButtonLabel', { ns: "common" })}
                            </button>
                            <button
                                style={{
                                    background: '#00508E',
                                    padding: '8px 32px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    display: 'block',
                                    cursor: 'pointer',
                                    border: '0',
                                    color: '#fff'
                                }}
                                onClick={() => goTo(3)}
                            >
                                {t('nextButtonLabel', { ns: "common" })}
                            </button>
                        </div>
                    </div>
                </div>
            ),
            style: {
                padding: '24px 32px',
                minWidth: '407px',
                background: '#003F75'
            }
        },
        {
            selector: '[data-tut="step_fresh_chat_tour"]',
            content: ({ goTo }) => (
                <div
                    dir={i18n.dir()}
                    style={{
                        marginRight: i18n.dir() === 'rtl' ? '10px' : '0'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <h4
                            style={{
                                color: '#fff',
                                fontSize: '18px',
                                fontWeight: '700',
                                lineHeight: '22px',
                                marginBottom: '12px'
                            }}
                        >
                            {t('tour.fourthStepTitle')}
                        </h4>
                    </div>
                    <p
                        style={{
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: '400',
                            lineHeight: '20px',
                            marginBottom: '16px'
                        }}
                    >
                        {t('tour.fourthStepOverView')}
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <p
                            style={{
                                color: '#fff',
                                fontSize: '14px',
                                fontWeight: '700',
                                lineHeight: '17px'
                            }}
                        >
                            {t("stepText", {currentStep: 4, endStep: 4, ns: "common"})}
                        </p>
                        <div
                            style={{
                                display: 'flex'
                            }}
                        >
                            <button
                                style={{
                                    background: '#00508E',
                                    padding: '8px 32px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    display: 'block',
                                    cursor: 'pointer',
                                    border: '0',
                                    color: '#fff'
                                }}
                                onClick={() => (window.location.href = '/settings')}
                            >
                                {t('nextButtonLabel', { ns: 'common' })}
                            </button>
                        </div>
                    </div>
                </div>
            ),
            style: {
                padding: '24px 32px',
                minWidth: '407px',
                background: '#003F75',
                transform: 'none',
                position: 'absolute',
                bottom: '30px',
                right: '97px',
                left: 'inherit',
                top: 'inherit'
            }
        }
    ];
}
